import Swiper from "swiper/dist/js/swiper.js";

export default {
    init() {

        /* NEWS SLIDER */
        const news_sliders = document.querySelectorAll('.home-news .swiper-container');
        
        if (news_sliders !== null) {
            for (let index = 0; index < news_sliders.length; index++) {
                let swiper = new Swiper(news_sliders[index], {
                    speed: 400,
                    slidesPerView: 3.25,
                    spaceBetween: 24,
                    touchRatio: 0,
                    loop: false,
                    navigation: {
                        nextEl: news_sliders[index].previousElementSibling.lastElementChild.querySelector('.swiper-button-next'),
                        prevEl: news_sliders[index].previousElementSibling.lastElementChild.querySelector('.swiper-button-prev'),
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                            touchRatio: 1
                        },
                        1025: {
                            slidesPerView: 2,
                        }
                    },
                });
            }
        }

        // banner flip
        const bannerWrapper = document.querySelector(".hero-banner .row");

        const flipBanner = () => {
            if (window.innerWidth < 767) {
                if (!bannerWrapper.classList.contains("moved")) {
                    bannerWrapper.classList.add("moved");
                    const image = bannerWrapper.lastElementChild;
                    bannerWrapper.insertAdjacentElement("afterbegin", image);
                }
            } else {
                if (bannerWrapper.classList.contains("moved")) {
                    bannerWrapper.classList.remove("moved");
                    const image = bannerWrapper.firstElementChild;
                    bannerWrapper.insertAdjacentElement("beforeend", image);
                }
            }
        }

        flipBanner();

        window.addEventListener("resize", flipBanner);

        // about flip
        const aboutWrapper = document.querySelector(".home-about .row");

        const flipAbout = () => {
            if (window.innerWidth < 767) {
                if (!aboutWrapper.classList.contains("moved")) {
                    aboutWrapper.classList.add("moved");
                    const image = aboutWrapper.lastElementChild;
                    aboutWrapper.insertAdjacentElement("afterbegin", image);
                }
            } else {
                if (aboutWrapper.classList.contains("moved")) {
                    aboutWrapper.classList.remove("moved");
                    const image = aboutWrapper.firstElementChild;
                    aboutWrapper.insertAdjacentElement("beforeend", image);
                }
            }
        }

        flipAbout();

        window.addEventListener("resize", flipAbout);
		
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
